import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Введение</Summary>
        <Details>
          <p>
            Настоящее Уведомление о конфиденциальности (далее «Уведомление»)
            составлено компанией AS&nbsp;PlusPlus Capital от имени PlusPlus
            Group. В нем описывается, как PlusPlus обрабатывает ваши
            персональные данные, и разъясняются ваше право на
            конфиденциальность. В тексте настоящего уведомления используются
            термины, определенные в «Общем регламенте по защите данных» (далее –
            GDPR, англ. <em>General Data Protection Regulation</em>) и в
            применимых законах.
          </p>
          <p>&nbsp;</p>
          <p>
            Настоящее уведомление адресовано физическому лицу, у которого или о
            котором мы получаем или собираем персональные данные в процессе
            оказания услуг или иной экономической деятельности (далее «вы» или
            «субъект прав»).
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus Group состоит из нескольких юридических лиц и, в
            зависимости от обстоятельства, соответствующая компания PlusPlus
            может выступать в роли оператора ваших данных (далее «мы» или
            «оператор персональных данных»). Контактные данные операторов
            персональных данных можно найти в конце данного Уведомления.
            Отношения между операторами данных внутри PlusPlus Group
            регулируются внутренними документами.
          </p>
          <p>&nbsp;</p>
          <p>
            По любым вопросам, связанным с обработкой ваших персональных данных
            или настоящим уведомлением, обращайтесь к нашему специалисту по
            защите данных по адресу электронной почты
            privacy(ат)pluspluscapital.eu.
          </p>
          <p>&nbsp;</p>
          <p>
            Существенные изменения настоящего уведомления будут опубликованы на
            нашей веб-странице, а при необходимости мы сообщим вам о внесенных
            изменениях по электронной почте.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Какие данные мы собираем о вас?</Summary>
        <Details>
          <p>
            Мы можем собирать, хранить, использовать, передавать и обрабатывать
            разные виды ваших персональных данных, которые можно объединить в
            следующие категории:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              Контактные данные (почтовый адрес, адрес электронной почты, номер
              телефона и т. п.)
            </li>
            <li>
              Идентификационные данные (имя и фамилия, личный код, дата и место
              рождения, гражданство, данные удостоверения личности и т.п.)
            </li>
            <li>
              Данные о трудоустройстве (настоящее место работы, прежние места
              работы, должность и т. п.)
            </li>
            <li>
              Данные о договорах и операциях (данные заявок и договоров,
              полученные PlusPlus, и данные из соответствующих документов, номер
              банковского счета, описание дохода, описание имущества, история
              платежей, связанных с приобретенными PlusPlus, данные о
              просроченных платежах, данные других лиц, имеющих отношение к
              приобретенным PlusPlus заявке или договору (например, поручители и
              со-получатели кредита, лица, предоставившие обеспечение) и т. п.)
            </li>
            <li>IP-адрес и аналитические данные</li>
          </ul>
          <p>
            IP-адрес — это уникальный цифровой адрес, который присваивается
            компьютеру при подключении к Интернету. Ваш IP-адрес записывается в
            лог-файл, когда вы пользуетесь чатом в реальном времени на нашей
            веб-странице. IP-адрес используется в технических целях, чтобы
            обеспечить работу и безопасность нашего вебсайта.
          </p>
          <p>
            Для хранения неперсонифицированных данных о том, как посетители
            используют наш вебсайт (количество просмотров нашей веб-страницы,
            используемые браузеры и устройства, просмотренный контент, в каком
            регионе находится пользователь и аналогичные статистические данные),
            мы используем Google Analytics – это нужно, чтобы улучшить работу
            нашего вебсайта. Подробнее о Google Analytics можно узнать здесь:
            https://support.google.com/analytics/answer/1012034?hl=en&ref_topic=6157800
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Откуда мы получаем ваши персональные данные?</Summary>
        <Details>
          <ul>
            <li>
              От третьих лиц (включая открытые источники), таких как продавцы
              требований или контрактов (первоначальные кредиторы),
              приобретенных компанией PlusPlus, лица, связанные с требованием
              или контрактом (поручители, совместные получатели кредита, лица,
              предоставившие обеспечение и т.&nbsp;п.), официальные учреждения
              (суды, судебные исполнители, банкротные управляющие и т. п.),
              путем поиска в электронных базах данных, предоставленных
              соответствующими продавцами услуг-третьими лицами (реестр
              неплательщиков, земельный реестр, коммерческий реестр и т. п.), а
              также из других открытых источников и посредством поисковых
              механизмов.
            </li>
            <li>От компаний, которые принадлежат концерну PlusPlus;</li>
            <li>
              От вас – вы сообщаете нам некоторые персональные данные напрямую
              по телефону, электронной почте или иным образом, когда
              связываетесь с нами (бланки, которые вы заполняете в системе
              самообслуживания, протоколы наших переговоров и переписки,
              различные юридические процедуры и т. п.)
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>
          Как мы используем (обрабатываем) ваши персональные данные?
        </Summary>
        <Details>
          <p>
            Мы будем обрабатывать ваши персональные данные для конкретных целей
            и в соответствии с GDPR и применимыми законами.
          </p>
          <p>&nbsp;</p>
          <p>
            В целом, мы обрабатываем ваши данные в указанных ниже целях и
            опираясь на соответствующие законы.
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              GDPR Статья 6 (1) (b)– для исполнения контракта, который вы
              подписали, или для подготовки к заключению контракта или другого
              договора, например, мы совершаем следующие действия:
              <ul>
                <li>
                  вносим ваши данные в соответствующие реестры для проверки
                  биографических данных и удовлетворения требований PlusPlus;
                </li>
                <li>
                  вносим ваши персональные данные в наши информационные системы;
                </li>
                <li>
                  обрабатываем и (или) исполняем требование, которое
                  предъявляется PlusPlus к вам или другому лицу (устанавливая
                  связь с вами или третьими лицами, или выполняя другие
                  действия, необходимые для удовлетворения требования).
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              GDPR Статья 6 (1) (c)– обработка необходима для обеспечения
              выполнения законодательных или нормативных обязательств, например:
              <ul>
                <li>
                  ведем бухгалтерский учет и проводим аудиторские проверки
                  PlusPlus.
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              GDPR Статья 6 (1) (f) – обработка необходима в наших законных
              интересах (занимаясь своей коммерческой деятельностью), если им не
              противоречат интересы, фундаментальные права и свободы субъекта
              данных, например:
              <ul>
                <li>
                  подготавливаем внутреннюю коммерческую отчетность и ведем
                  обмен информацией внутри компании;
                </li>
                <li>
                  консультируем вас о том, как вы можете эффективно выполнять
                  свои обязательства перед PlusPlus;
                </li>
                <li>
                  разрабатываем свои ИТ системы, веб-страницы и системы
                  самообслуживания.
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              GDPR Статья (1) (a) — если вы дали согласие на обработку ваших
              персональных данных в целях, указанных при получении вашего
              согласия.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Разглашение ваших персональных данных</Summary>
        <Details>
          <p>
            Мы можем передать ваши персональные данные третьим лицам, которые
            оказывают нам услуги по ведению коммерческой деятельности, или
            которые участвуют в обработке и (или) реализации требований,
            выдвинутых PlusPlus в отношении вас или другого лица (см. выше
            категории целей обработки).
          </p>
          <p>&nbsp;</p>
          <p>
            Мы требуем, чтобы наши поставщики услуг — третьи лица защищали ваши
            данные, обрабатывали эти данные в соответствии с нашими инструкциями
            и требованиями, отвечающими положениям настоящего уведомления, GDPR
            и применимого закона. Указанные третьи лица имеют право использовать
            ваши персональные данные только в указанных целях в рамках тех
            услуг, которые они нам оказывают.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Передача за пределами ЕЭЗ</Summary>
        <Details>
          <p>
            Для осуществления своей коммерческой деятельности мы можем
            передавать ваши персональные данные для обработки получателям,
            расположенным за пределами Европейской экономической зоны (далее –
            ЕЭЗ). Например, серверы по обработке данных наших
            поставщиков-третьих лиц могут находиться за пределами ЕЭЗ. Вы можете
            получить дополнительную информацию или копию соответствующих или
            подходящих мер защиты, связавшись с нами по адресу электронной почты
            privacy(ат)pluspluscapital.eu.
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus принимает все меры для обеспечения надежной защиты данных
            за пределами ЕЭЗ в соответствии с положениями настоящего
            уведомления, GDPR и применимого законодательства. Что касается
            передачи данных в страны, не обеспечивающие необходимый уровень
            защиты данных, то в этом случае мы организуем передачу данных при
            условии исполнения определенных обязательств получателем, таких как
            стандартные условия защиты данных, установленные Европейской
            комиссией, или использование утвержденных механизмов сертификации в
            сочетании с обязательными к исполнению требованиями к получателю.
            Если персональные данные передаются в США, то получатель может
            входить в систему защиты персональной информации ЕС-США, а значит,
            предполагается, что он обеспечивает достаточный уровень защиты
            данных и способствует обмену информацией между ЕС и США.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Хранение и безопасность ваших персональных данных</Summary>
        <Details>
          <p>
            Мы будем обрабатывать ваши персональные данные в течение исполнения
            договора или другого соглашения, а затем будем хранить ваши
            персональные данные в течение срока, необходимого для достижения тех
            целей, для которых мы их собирали, и для исполнения наших
            юридических, налоговых и бухгалтерских обязательств.
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            Персональные данные, связанные с контрактами и (или) сделками входят
            в состав наших бухгалтерских и коммерческих документов, и мы их
            храним не менее 10 лет после окончания отчетного года. Срок хранения
            может быть дольше, если обработка ваших персональных данных
            подчиняется другим применимым законам или должна соответствовать
            другим требованиям, связанным с нашей основной коммерческой
            деятельностью (например, для исполнения или защиты юридического
            требования). После окончания срока хранения мы либо уничтожим ваши
            персональные данные, либо обезличим их.
          </p>
          <p>&nbsp;</p>
          <p>
            Мы храним неперсонифицированные и статистические данные об
            использовании наших веб-страниц в течение 3 лет.
          </p>
          <p>&nbsp;</p>
          <p>
            Мы внедрили общепринятые стандарты технологий и операционной
            безопасности для защиты ваших личных данных от потери, неправильного
            использования, изменения или уничтожения. Мы требуем, чтобы весь
            персонал сохранял конфиденциальность личных данных, и только
            уполномоченный персонал имеет доступ к этим данным.
          </p>
          <p>&nbsp;</p>
          <p>
            Мы принимаем меры, чтобы обеспечить надлежащую безопасность и защиту
            ваших прав на конфиденциальность.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Ваши права</Summary>
        <Details>
          <p>
            У вас есть различные права в отношении ваших персональных данных,
            которые мы обрабатываем:
          </p>
          <ul>
            <li>
              <strong>Право запрашивать доступ:</strong> вы можете в любое время
              попросить нас подтвердить, какую информацию о вас мы обрабатываем.
              Если это требуется по закону, мы можем отклонить ваш запрос. Если
              мы отклоним ваш запрос, мы сообщим вам причины этого.
            </li>
            <li>
              <strong>Право на исправление:</strong> вы можете потребовать,
              чтобы мы исправили любые ваши неточные или неполные личные данные,
              которые мы обрабатываем. Если мы передали эти персональные данные
              третьим лицам, мы уведомим их об исправлении, если это не
              невозможно или не требует непропорциональных усилий. Если это
              разрешено законом, мы можем отклонить ваш запрос. Если мы отклоним
              ваш запрос, мы сообщим вам причины этого.
            </li>
            <li>
              <strong>Право на уничтожение:</strong> вы имеете право
              потребовать, чтобы мы уничтожили ваши личные данные при
              определенных обстоятельствах. Если это разрешено законом, мы можем
              отклонить ваш запрос. Если мы отклоним ваш запрос, мы сообщим вам
              причины этого.
            </li>
            <li>
              <strong>Право ограничить обработку:</strong> вы имеете право
              ограничить обработку ваших личных данных при определенных
              обстоятельствах. Это означает, что мы можем только продолжать
              хранить ваши данные и не сможем выполнять какие-либо дальнейшие
              действия по обработке. Если это разрешено законом, мы можем
              отклонить ваш запрос. Если мы отклоним ваш запрос, мы сообщим вам
              причины этого.
            </li>
            <li>
              <strong>Право на возражение:</strong> при определенных
              обстоятельствах вы имеете право возражать против обработки нами
              ваших личных данных. Если это разрешено законом, мы можем
              отклонить ваш запрос. Если мы отклоним ваш запрос, мы сообщим вам
              причины этого.
            </li>
            <li>
              <strong>Право на переносимость данных:</strong> вы имеете право
              передавать свои личные данные между контроллерами данных с учетом
              возможных ограничений применимого законодательства. Это означает,
              что вы можете передавать данные о вас, которые мы обрабатываем,
              другому поставщику услуг или третьей стороне. Мы предоставим вам
              ваши данные в широко используемом машиночитаемом формате, чтобы вы
              могли передать их другому поставщику услуг.
            </li>
            <li>
              <strong>
                Право не подчиняться решению, основанному исключительно на
                автоматизированной обработке:
              </strong>{" "}
              вы имеете право не подчиняться решению, основанному исключительно
              на автоматизированной обработке, включая профилирование, которое
              имеет правовые последствия в отношении вас или аналогичным образом
              влияет на вас. Это право подлежит ограничениям применимого
              законодательства. Если это разрешено законом, мы можем отклонить
              ваш запрос. Если мы отклоним ваш запрос, мы сообщим вам причины
              этого.
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            Вы можете воспользоваться своими правами в соответствии с
            требованиями GDPR и других применимых законов.
          </p>
          <p>&nbsp;</p>
          <p>
            Чтобы воспользоваться своими правами, свяжитесь с нами по
            электронной почте privacy(ат)pluspluscapital.eu. Мы можем запросить
            у вас определенные сведения или документы, подтверждающие вашу
            личность в общении с нами относительно ваших прав на
            конфиденциальность. Это необходимо, чтобы не допустить раскрытия
            ваших персональных данных лицам, которые не являются вами и не имеют
            права получать ваши персональные данные.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Право подать жалобу</Summary>
        <Details>
          <p>
            Если вы считаете, что ваши права на конфиденциальность нарушены, вы
            имеете право подать жалобу в государственные органы страны своего
            постоянного проживания. Контактные данные таких органов можно найти
            здесь:{" "}
            <a href="https://edpb.europa.eu/about-edpb/board/members_en">
              https://edpb.europa.eu/about-edpb/board/members_en
            </a>
            .
          </p>
          <p>
            <strong>&nbsp;</strong>
          </p>
          <p>
            <strong>Список операторов данных:</strong>
          </p>
          <ul>
            <li>
              <strong>AS PlusPlus Capital</strong>, адрес Тарту мнт. 83,
              Таллинн, 10115 Эстония, тел. +372 6224020, э-почта:
              privacy(ат)plusplus.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OÜ</strong>, адрес Тарту мнт. 83, Таллинн,
              10115 Эстония, тел. +372 6224020, э-почта: privacy(ат)plusplus.eu;
            </li>
            <li>
              <strong>PlusPlus Legal OÜ</strong>, адрес Тарту мнт. 83, Таллинн,
              10115 Эстония, тел. +372 6224020, э-почта: privacy(ат)plusplus.eu;
            </li>
            <li>
              <strong>
                Ārvalsts komersanta PlusPlus Baltic OU filiāle Latvijā
              </strong>
              , адрес Akmenu iela 14, ,Рига LV-1048 Латвия, тел. +371 29401576,
              э-почта: privacy(ат)plusplus.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OU Lietuvos filialas</strong>, адрес
              Gynėjų g. 16, Вильнюс, LT-01109 Литва, тел. +370 67490065,
              э-почта: privacy(ат)plusplus.eu;
            </li>
            <li>
              <strong>PlusPlus</strong>
              <strong> Capital</strong>
              <strong> Oy</strong>, адрес Kasarmikatu 23 A 7, Хельсинки, 00130
              Финляндия, тел. +358 974790202, э-почта:
              privacy(ат)pluspluscapital.eu.
            </li>
          </ul>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
